import styles from './Container.module.css';

interface ContainerProps {
  children: React.ReactNode;
  width?: 'default' | 'narrow' | 'wide';
  className?: string;
}

export function Container({ children, width = 'default', className = '' }: ContainerProps) {
  return (
    <div
      className={[
        styles.container,
        width !== 'default' ? styles[width] : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}
